<template>
    <div>
        <el-form ref="form" :inline="true" class="query-form" size="mini" @submit.native.prevent="onSubmit">
            <el-form-item class="query-form-item">

                <el-form-item label="ID:" class="query-form-item">
                    <el-input style="width: 100px;" clearable v-model="query.id" placeholder="请输入ID"
                              size="mini"></el-input>
                </el-form-item>
                <el-form-item label="类目：" class="query-form-item" prop="developer_id">
                    <el-select v-model="query.category_id" placeholder="请选择" size="mini" filterable
                               style="width: 110px;">
                        <el-option label="全部" value=""></el-option>
                        <el-option :label="item.name" :value="item.id" v-for="item in filterCategoryList"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="竞品ASIN：" class="query-form-item">
                    <el-input style="width: 150px;" clearable v-model="query.asin" placeholder="请输入竞品ASIN"
                              size="mini"></el-input>
                </el-form-item>
                <el-form-item label="是否有专利值:" class="query-form-item">
                    <el-select v-model="query.has_patent_value" placeholder="状态" size="mini" style="width: 100px;">
                        <el-option label="全部" value=""></el-option>
                        <el-option label="有" :value="1"></el-option>
                        <el-option label="没有" :value="0"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="是否季节性：" class="query-form-item">
                    <el-select v-model="query.is_seasonality" placeholder="季节性" size="mini" style="width: 100px;">
                        <el-option label="全部" :value="undefined"></el-option>
                        <el-option label="是" :value="1"></el-option>
                        <el-option label="否" :value="0"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="季节：" class="query-form-item">
                    <el-select v-model="query.season" placeholder="请选择" size="mini" filterable style="width: 100px;">
                        <el-option :label="item.label" :value="item.value"
                                   v-for="item in $common.seasonArr"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="标题：" class="query-form-item">
                    <el-input style="width: 150px;" clearable v-model="query.title"
                              placeholder="请输入标题" size="mini"></el-input>
                </el-form-item>

                <el-form-item label="重(g):" class="query-form-item">
                    <el-input style="width: 90px;" clearable v-model="query.min_weight"
                              placeholder="最小" size="mini"></el-input>
                    -
                    <el-input style="width: 90px;" clearable v-model="query.max_weight"
                              placeholder="最大" size="mini"></el-input>
                </el-form-item>

                <el-form-item label="销售价格：" class="query-form-item">
                    <el-input style="width: 90px;" clearable v-model="query.min_selling_price"
                              placeholder="最小" size="mini"></el-input>
                    -
                    <el-input style="width: 90px;" clearable v-model="query.max_selling_price"
                              placeholder="最大" size="mini"></el-input>
                </el-form-item>

                <el-form-item label="利润：" class="query-form-item">
                    <el-input style="width: 70px;" clearable v-model="query.min_profit"
                              placeholder="最小" size="mini"></el-input>
                    -
                    <el-input style="width: 70px;" clearable v-model="query.max_profit"
                              placeholder="最大" size="mini"></el-input>
                </el-form-item>

                <el-form-item label="利润率(%):" class="query-form-item">
                    <el-input-number style="width: 110px;" clearable v-model="query.min_profit_rate"
                                     placeholder="最小" size="mini" :step="0.1" :min="0"></el-input-number>
                    -
                    <el-input-number style="width: 110px;" clearable v-model="query.max_profit_rate"
                                     placeholder="最大" size="mini" :step="0.1" :min="0"></el-input-number>
                </el-form-item>

                <el-form-item label="投资回报率(%):" class="query-form-item">
                    <el-input-number style="width: 110px;" clearable v-model="query.min_investment_return_rate"
                                     placeholder="最小" size="mini" :step="0.1" :min="0"></el-input-number>
                    -
                    <el-input-number style="width: 110px;" clearable v-model="query.max_investment_return_rate"
                                     placeholder="最大" size="mini" :step="0.1" :min="0"></el-input-number>
                </el-form-item>

                <el-form-item label="确认销售价格：" class="query-form-item">
                    <el-select v-model="query.confirm_selling_price" placeholder="请选择" size="mini"
                               style="width: 110px;">
                        <el-option label="全部" :value="null"></el-option>
                        <el-option label="是" :value="1"></el-option>
                        <el-option label="否" :value="0"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="确认1688链接：" class="query-form-item">
                    <el-select v-model="query.confirm_ali_message" placeholder="请选择" size="mini"
                               style="width: 110px;">
                        <el-option label="全部" :value="null"></el-option>
                        <el-option label="是" :value="1"></el-option>
                        <el-option label="否" :value="0"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="是否我的选品：" class="query-form-item">
                    <el-select v-model="query.is_my_analysis" placeholder="请选择" size="mini" style="width: 100px;">
                        <el-option label="全部" :value="undefined"></el-option>
                        <el-option label="我的选品" :value="1"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="忽略原因：">
                    <el-input style="width: 150px;" clearable v-model="query.disregarded_reason"
                              placeholder="请输入忽略原因" size="mini"></el-input>
                </el-form-item>

                <el-button type="primary" @click="onSubmit" size="mini" native-type="submit">查询</el-button>
            </el-form-item>
        </el-form>
        <el-table v-loading="loading" :data="list" :height="tableHeight" size="mini" ref="multipleTable"
                  @row-click="clickRowHandle" @header-click="clickHeaderHandle"
                  @selection-change="handleSelectionChange"
                  class="table_content mini_div" border @sort-change="handleSortChange" style="width: 100%;">
            <el-table-column label="ID" width="60" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.id }}</div>
                </template>
            </el-table-column>
            <el-table-column label="图片" width="120" align="center">
                <template slot-scope="scope">
                    <div v-if="!scope.row.img_url">暂无图片</div>
                    <img style="width:90px;height:90px;" :src="scope.row.img_url" v-else/>
                </template>
            </el-table-column>
            <table-asin-column></table-asin-column>

            <el-table-column label="销售国家" width="80" align="center">
                <template slot-scope="scope">
                    <div>
                        <icon-svg
                            :icon-class="scope.row.category_state.toUpperCase()"
                            style="font-size: 24px;margin-left:5px;"
                        ></icon-svg>
                    </div>
                </template>
            </el-table-column>

            <el-table-column label="类目" min-width="360" align="center">
                <template slot-scope="scope">
                    <div class="fixedHeight">{{ scope.row.category }}</div>
                </template>
            </el-table-column>

            <el-table-column label="忽略原因" width="150" align="center">
                <template slot-scope="scope">
                    <div>
                        {{ scope.row.disregarded_reason }}
                    </div>
                </template>
            </el-table-column>

            <el-table-column label="确认销售价格" min-width="150" align="center">
                <template slot-scope="scope">
                    <div class="fixedHeight">{{ scope.row.confirm_selling_price == 1 ? '是' : '否' }}</div>
                </template>
            </el-table-column>
            <el-table-column label="确认1688链接" min-width="150" align="center">
                <template slot-scope="scope">
                    <div class="fixedHeight">{{ scope.row.confirm_ali_message == 1 ? '是' : '否' }}</div>
                </template>
            </el-table-column>

            <el-table-column label="专利" min-width="120" align="center">
                <template slot-scope="scope">
                    <el-button type="primary" @click="updateVal(scope.row)" size="mini">{{scope.row.patent_value ? scope.row.patent_value : '-'}}</el-button><br/><br/>
                    <el-button type="success" @click="uploadPatentFile(scope.row)" size="mini">上传</el-button>
                    <el-button type="success" @click="downFile(scope.row.patent_file)" size="mini" :disabled="!scope.row.patent_file">下载</el-button>
                </template>
            </el-table-column>

            <el-table-column label="标题" min-width="150" align="center">
                <template slot-scope="scope">
                    <div class="fixedHeight">{{ scope.row.title }}</div>
                </template>
            </el-table-column>

            <el-table-column label="备注" align="center" :show-overflow-tooltip="true" width="220">
                <template slot-scope="scope">
                    <span>{{ scope.row.remark }}</span>
                </template>
            </el-table-column>

            <el-table-column label="销售价格" width="80" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.selling_price }}</div>
                </template>
            </el-table-column>

            <el-table-column label="1688产品链接" min-width="100" align="center">
                <template slot-scope="scope">
                    <el-button v-show="scope.row.ali_href_link" type="primary" size="mini"
                               @click="jumpUrl(scope.row.ali_href_link)">跳转
                    </el-button>
                </template>
            </el-table-column>

            <el-table-column label="1688产品价格" min-width="100" align="center">
                <template slot-scope="scope">
                    <div class="fixedHeight">{{ scope.row.ali_factory_price }}</div>
                </template>
            </el-table-column>

            <el-table-column label="1688产品图片" width="120" align="center">
                <template slot-scope="scope">
                    <div v-if="!scope.row.ali_pic_url">暂无图片</div>
                    <img style="width:90px;height:90px;" :src="scope.row.ali_pic_url" v-else/>
                </template>
            </el-table-column>

            <el-table-column label="1688产品标题" width="120" align="center">
                <template slot-scope="scope">
                    <div class="fixedHeight">{{ scope.row.ali_title }}</div>
                </template>
            </el-table-column>

            <el-table-column label="退货率" width="100" align="center">
                <template slot-scope="scope">
                    <div>{{ parseFloat((scope.row.refund_rate || 0) * 100).toFixed(2) }}%</div>
                </template>
            </el-table-column>

            <el-table-column label="长(cm)*宽(cm)*高(cm)-重(g)" width="190" align="center">
                <template slot-scope="scope">
                    <div>
                        {{ scope.row.long }}*{{ scope.row.wide }}*{{
                            scope.row.height
                        }}-{{ scope.row.weight }}
                    </div>
                </template>
            </el-table-column>

            <el-table-column label="运费" width="70" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.freight }}</div>
                </template>
            </el-table-column>

            <el-table-column label="平台佣金" width="70" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.platform_commission }}</div>
                </template>
            </el-table-column>

            <el-table-column label="配送费" min-width="120" align="center">
                <template slot-scope="scope">
                    <div class="fixedHeight">{{ scope.row.delivery_charge }}</div>
                </template>
            </el-table-column>
            <el-table-column label="退货费用" width="70" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.refund_charge }}</div>
                </template>
            </el-table-column>

            <el-table-column label="仓储费" width="100" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.storage_charge }}</div>
                </template>
            </el-table-column>
            <el-table-column label="0利润销售价格" width="100" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.seller_price_no_profit }}</div>
                </template>
            </el-table-column>

            <el-table-column label="利润" width="80" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.profit }}</div>
                </template>
            </el-table-column>
            <el-table-column label="利润率" width="130" align="center">
                <template slot-scope="scope">
                    <div>{{scope.row['profit_rate'] ? accMul(scope.row['profit_rate'], 100) + '%' : '-' }}</div>
                </template>
            </el-table-column>
            <el-table-column label="投资回报率" width="130" align="center">
                <template slot-scope="scope">
                    <div>{{
                            scope.row['investment_return_rate'] ? accMul(scope.row['investment_return_rate'], 100) + '%' : '-'
                        }}
                    </div>
                </template>
            </el-table-column>

            <el-table-column label="是否季节性" width="90" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.is_seasonality == 1 ? '是' : '否' }}</div>
                </template>
            </el-table-column>


            <el-table-column label="季节" width="120" align="center">
                <template slot-scope="scope">
                    <div class="fixedHeight">{{ scope.row.season }}</div>
                </template>
            </el-table-column>

            <el-table-column label="创建时间" width="140" align="center">
                <template slot-scope="scope">
                    <div class="fixedHeight">{{ scope.row.create_time }}</div>
                </template>
            </el-table-column>
            <el-table-column label="分配采购时间" width="140" align="center">
                <template slot-scope="scope">
                    <div class="fixedHeight">{{ scope.row.assign_developer_time }}</div>
                </template>
            </el-table-column>


            <el-table-column label="操作" width="290" align="center" fixed="right">
                <template slot-scope="scope">
<!--                    <el-button type="primary" size="mini" @click="operateFunc(scope.row, 1)">-->
<!--                        操作-->
<!--                    </el-button>-->
                    <el-button type="success" size="mini" @click="detailFunc(scope.row)">
                        详情
                    </el-button>
<!--                    <el-button type="success" size="mini" @click="exportFunc(scope.row)">-->
<!--                        导出-->
<!--                    </el-button>-->
<!--                    <el-button type="primary" size="mini" @click="purchaseFunc(scope.row)">-->
<!--                        采购-->
<!--                    </el-button>-->
                    <el-button type="danger" size="mini" @click="deleteFunc(scope.row)">
                        删除
                    </el-button>
                </template>
            </el-table-column>

        </el-table>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-size="query.limit"
                       :page-sizes="[10, 20, 50]" :total="query.total" background :current-page="query.page"
                       style="margin-top: 10px;display: flex;justify-content: end;"
                       layout="total, sizes, prev, pager, next">
        </el-pagination>
        <child-info-modal :visible="ctrl.childInfoVisible" :info="childInfo"
                          @close-callback="closeCllback"></child-info-modal>
        <addBid
            :visible="showAddRecord"
            :title="editType == 0 ?'添加爬取排名Asin任务' : '成本分析操作'"
            :copyData="copyData"
            :editType='editType'
            @close-callback="closeCllback"
            @refreshList="refreshList"
        ></addBid>
        <detail-preview ref="detailPreview"></detail-preview>
        <self-build-modal :visible="showSelfBuild" @click="closeCllback" @showDetail="showDetail"
                          @close-callback="closeCllback"></self-build-modal>
        <car-modal ref="card"></car-modal>
        <updatePatent ref="updatePatentDom" @close-callback="closeCllback"/>
        <child-info-modal :visible="ctrl.childInfoVisible" :info="childInfo"
                          @close-callback="closeCllback"></child-info-modal>
    </div>
</template>

<script>
import * as api from '@/api/advAnalys/advAnalys.js'
import addBid from './addBid1'
import {downloadFileUrl} from '@/utils/method'
import ChildInfoModal from '@/views/costAnalysis/childInfoModal.vue'
import DetailPreview from './lowPriceDetailPreview.vue'
import SelfBuildModal from '@/views/costAnalysis/selfBuildModal.vue'
import CarModal from './lowPriceCarModal.vue'
import updatePatent from './updatePatent.vue'
import {low_price_mall_cost_analysis_low_price_mall_disregarded_list} from '@/api/advAnalys/advAnalys.js'

let timer = null
export default {
    name: 'myChoice',
    components: {
        updatePatent,
        CarModal,
        SelfBuildModal,
        DetailPreview,
        ChildInfoModal,
        // BasicConfigurationData,
        addBid,
        // categoryList,
        // addParse,
    },
    computed: {
        showUnassign() {
            return this.$checkPermission('admin/cost_analysis/personal/cancel_assign')
        },
        showOperate() {
            return this.$checkPermission('admin/cost_analysis/personal/cancel_assign')
        },
        showPurchase() {
            return this.$checkPermission('admin/cost_analysis/personal/cancel_assign')
        },
    },
    data() {
        return {
            categoryList: [],
            showSelfBuild: false,
            managerAnalysisList: [],
            rootCategoryList: [],
            usList: [],
            ukList: [],
            deList: [],
            imgStatusList: [
                {name: '全部', value: undefined},
                {name: '搜索不到图片', value: 1},
                {name: '暂无图片', value: 2},
                {name: '有图片', value: 3},
            ],
            isFold: true,
            editType: 0,
            copyData: {},
            manualRootShow: false,
            showBasicConfigDataModal: false,
            showAddParseModal: false,
            showCategoryList: false,
            manualRootList: [],
            showAddRecord: false,
            currentId: '',
            tableHeight: null,
            errorMsg: '',
            errorInfoShow: false,
            ctrl: {
                DownloadListDialogVisible: false,
                uploadDialogVisible: false,
                bidDialogVisible: false,
                childInfoVisible: false,
            },
            typeArr: [{
                index: 1,
                title: '广告层面'
            },
                {
                    index: 2,
                    title: '逻辑层面'
                }
            ],
            query: {
                is_seasonality: undefined,
                category_id: '',
                category_state: '',
                asin: '',
                id: '',
                developer_id: '',
                season: undefined,
                min_freight_difference: undefined,
                max_freight_difference: undefined,
                min_weight: undefined,
                max_weight: undefined,
                min_profit: undefined,
                max_profit: undefined,
                min_selling_price: undefined,
                max_selling_price: undefined,
                page: 1,
                limit: 10,
                total: 0,
            },
            record_id: 0,
            activeName: 'antiInternal',
            list: [],
            disabled: false,
            listDisabled: false,
            loading: false,
            parseStatusList: [],
            updateData: {},
            childInfo: {},
            multipleSelection: [],
        }
    },
    mounted() {
        this.getCategoryList()
        // this.getManagerAnalysisList()
        this.getList()
        this.tableHeight =
            window.innerHeight - 140 - this.$refs.form.$el.offsetHeight
        const that = this
        window.onresize = () => {
            return (() => {
                if (typeof that.$refs.form == 'object') {
                    that.tableHeight =
                        window.innerHeight -
                        140 -
                        that.$refs.form.$el.offsetHeight
                }
            })()
        }
    },
    watch: {
        tableHeight(val) {
            this.tableHeight = val
        },
        'query.category_state': {
            handler(val) {
                this.filterCategoryList = ['', undefined, null].includes(val) ? this.categoryList : this.categoryList.filter(item => {
                    if (item.name.indexOf(`${val}-`) !== -1) {
                        return item
                    }
                })
                this.getDeliverModeArr = ['', undefined, null].includes(val) ? this.$common.deliverModeArr : this.$common.deliverModeArr.filter(item => item.nation == val || item.value == '')
                this.$set(this.query, 'category_id', '')
            },
            deep: true,
            immediate: true
        },
        categoryList: {
            handler() {
                const val = this.query.category_state
                this.filterCategoryList = ['', undefined, null].includes(val) ? this.categoryList : this.categoryList.filter(item => {
                    if (item.name.indexOf(`${val}-`) !== -1) {
                        return item
                    }
                })
            },
            deep: true,
        }
    },
    destroyed() {
        clearInterval(timer)
    },
    methods: {
        getCategoryList() {
            api.manager_index_get_category_message().then(res => {
                this.loading = false
                if (res.code === 0) {
                    this.categoryList = res.data || []
                } else {
                    this.$message({
                        type: 'error',
                        message: res.message
                    })
                }
            }).catch(() => {
                this.loading = false
            })
        },

        deleteFunc(data) {
            this.$confirm('确认删除该记录吗?', '提示', {
                type: 'warning'
            }).then(() => {
                api.low_price_mall_developer_deleted({id: data.id}).then((res) => {
                    if (res.success) {
                        this.$message.success('删除成功')
                        this.getList()
                    } else {
                        this.$message({type: 'error', message: res.message})
                    }
                })
            })
        },
        cardFunc(data) {
            api.low_price_mall_cost_analysis_get_cost_analysis_card({id: data.id}).then(res => {
                if (res.success) {
                    this.$refs.card.showModal(res.data)
                } else {
                    this.$message({type: 'error', message: res.message})
                }
            })
        },
        detailFunc(data) {
            this.$refs.detailPreview.visible = true
            this.$refs.detailPreview.title = '详情展示'
            this.$refs.detailPreview.formData = data
        },
        exportFunc(data) {
            api.low_price_mall_commonExport({id: data.id}).then((res) => {
                if (res.success) {
                    this.downFile(res.data)
                } else {
                    this.$message({
                        type: 'error',
                        message: res.message
                    })
                }
            })
        },
        // 取消分配
        unassignFunc(data) {
            api.cost_analysis_personal_cancel_assign({id: data.id}).then((res) => {
                if (res.success) {
                    this.$message.success('取消分配成功')
                    this.getList()
                } else {
                    this.$message.error('取消分配失败，请联系管理员')
                }
            })
        },
        // 操作
        operateFunc(data, type) {
            let tempDate = JSON.parse(JSON.stringify(data))
            this.editType = type
            this.copyData = tempDate
            this.showAddRecord = true
        },
        // 采购
        purchaseFunc(data) {
            api.low_price_mall_developer_purchase({id: data.id}).then((res) => {
                if (res.success) {
                    this.$message.success('采购成功')
                    this.getList()
                } else {
                    this.$message.error(res.message)
                }
            })
        },
        // 关闭弹窗
        handleClose(isshow = false) {
            this.loading = false
            this.$emit('close-callback', isshow)
        },
        handleSelectionChange(val) {
            let arr = []
            val.map(v => {
                arr.push(v.id)
            })
            arr = Array.from(new Set(arr))
            this.multipleSelection = arr
        },
        seeUrl(row) {
            this.childInfo.title = '1688链接'
            this.childInfo.info = row.href_link
            this.ctrl.childInfoVisible = true
        },
        jumpUrl(url) {
            window.open(url, '_blank')
        },
        //跳转到亚马逊产品页面
        edirectToAsin(data) {
            // let url =
            //     link_us(data.state) +
            //     'dp/' +
            //     data.url_asin_href +
            //     '?th=1&psc=1'
            window.open(data.href_link, '_blank')
        },
        /**
         * 数字相乘
         * @param {*} arg1
         * @param {*} arg2
         * @returns
         */
        accMul(arg1, arg2) {
            let m = 0
            m = this.accAdd(m, this.getDecimalLength(arg1))
            m = this.accAdd(m, this.getDecimalLength(arg2))
            return this.getNum(arg1) * this.getNum(arg2) / Math.pow(10, m)
        },
        getNum(arg = '') {
            return Number(arg.toString().replace('.', ''))
        },
        /**
         * 数字相加
         * @param {*} arg1
         * @param {*} arg2
         * @returns
         */
        accAdd(arg1, arg2) {
            return this.changeNum(arg1, arg2)
        },
        changeNum(arg1 = '', arg2 = '', isAdd = true) {
            const changeInteger = (arg, r, maxR) => {
                if (r != maxR) {
                    let addZero = ''
                    for (let i = 0; i < maxR - r; i++) {
                        addZero += '0'
                    }
                    arg = Number(arg.toString().replace('.', '') + addZero)
                } else {
                    arg = this.getNum(arg)
                }
                return arg
            }

            let r1, r2, maxR, m
            r1 = this.getDecimalLength(arg1)
            r2 = this.getDecimalLength(arg2)
            maxR = Math.max(r1, r2)
            arg1 = changeInteger(arg1, r1, maxR)
            arg2 = changeInteger(arg2, r2, maxR)
            m = Math.pow(10, maxR)
            if (isAdd) {
                return (arg1 + arg2) / m
            } else {
                return (arg1 - arg2) / m
            }
        },

        getDecimalLength(arg = '') {
            try {
                return arg.toString().split('.')[1].length
            } catch (e) {
                return 0
            }
        },

        spanMethod({row, column, rowIndex, columnIndex}) {

            const columns = [13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28]
            if (rowIndex % 3 == 0) {
                if (columns.includes(columnIndex)) {
                    return {
                        rowspan: 1,
                        colspan: 1
                    }
                }
                return {
                    rowspan: 3,
                    colspan: 1
                }
            } else {
                if (columns.includes(columnIndex)) {
                    return {
                        rowspan: 1,
                        colspan: 1
                    }
                }
                return {
                    rowspan: 0,
                    colspan: 0
                }
            }
        },
        copyDataFunc(data, type) {
            this.showAddRecord = true
            let tempDate = JSON.parse(JSON.stringify(data))
            tempDate.is_peak_season = tempDate.is_peak_season == 1 ? true : false
            tempDate.is_seasonality = tempDate.is_seasonality == 1 ? true : false
            this.editType = type
            this.copyData = tempDate
        },
        delete_records(data) {
            this.$confirm('确认删除该记录吗?', '提示', {
                type: 'warning'
            }).then(() => {
                api.variety_cost_control_analysis_delete({ids: [data.id]}).then(() => {
                    this.$message.success('删除成功')
                    this.getList()
                })
            })
        },
        showErrorInfo(info) {
            this.errorInfoShow = true
            this.errorMsg = info.parsing_err_msg
        },
        showManualRoot(info) {
            this.manualRootShow = true
            this.manualRootList = info
        },
        getManagerAnalysisList() {
            api.manager_index_get_developer_list().then(res => {
                this.loading = false
                if (res.code === 0) {
                    const responseList = res.data || []
                    this.managerAnalysisList = responseList
                } else {
                    this.$message({
                        type: 'error',
                        message: res.message
                    })
                }
            }).catch(() => {
                this.loading = false
            })
        },
        getList() {
            this.loading = true

            let tempQuery = JSON.parse(JSON.stringify(this.query))

            if (tempQuery.min_profit_rate !== null) {
                tempQuery.min_profit_rate = tempQuery.min_profit_rate == 0 ? 0 : tempQuery.min_profit_rate / 100
            }
            if (tempQuery.max_profit_rate !== null) {
                tempQuery.max_profit_rate = tempQuery.max_profit_rate == 0 ? 0 : tempQuery.max_profit_rate / 100
            }
            if (tempQuery.min_investment_return_rate !== null) {
                tempQuery.min_investment_return_rate = tempQuery.min_investment_return_rate == 0 ? 0 : tempQuery.min_investment_return_rate / 100
            }
            if (tempQuery.max_investment_return_rate !== null) {
                tempQuery.max_investment_return_rate = tempQuery.max_investment_return_rate == 0 ? 0 : tempQuery.max_investment_return_rate / 100
            }

            api.low_price_mall_cost_analysis_low_price_mall_disregarded_list(tempQuery).then(res => {
                this.loading = false
                if (res.code === 0) {
                    const responseList = res.data.list || []
                    this.list = responseList
                    this.query.total = res.data.total
                } else {
                    this.$message({
                        type: 'error',
                        message: res.message
                    })
                }
            }).catch(() => {
                this.loading = false
            })
        },
        clickRowHandle(row, column) {
            let update = false

            if (['标题', '类目树', '子类目', '1688产品标题', '颜色', '备注'].includes(column.label)) {
                this.childInfo.title = column.label
                let info = row.title
                if (column.label == '类目树') {
                    info = row.category_tree
                } else if (column.label == '子类目') {
                    info = row.categories_str
                } else if (column.label == '颜色') {
                    info = row.color
                } else if (column.label == '1688产品标题') {
                    info = row.ali_title
                } else if (column.label == '备注') {
                    info = row.remark
                    update = true
                }
                this.childInfo.id = row.id
                this.childInfo.update = update
                this.childInfo.info = info
                this.ctrl.childInfoVisible = true
            }
            if (['折叠', '收起'].includes(column.label)) {
                this.isFold = !this.isFold
            }
        },
        clickHeaderHandle(row, column) {
            if (['折叠', '收起'].includes(row.label)) {
                this.isFold = !this.isFold
            }
        },
        handleSortChange(val) {
            if (val.order == 'ascending') {
                this.query.desc = 'desc'
                this.query.order = val.prop
            } else if (val.order == 'descending') {
                this.query.desc = 'asc'
                this.query.order = val.prop
            }
            this.getList()
        },
        handleClick(tab) {
            this.$nextTick(() => {
                this.$refs[tab.paneName].getList()
            })
        },
        onSelfBuild() {
            this.showSelfBuild = true
        },
        //重置
        onReset() {
            this.query = {
                category_id: '',
                category_state: '',
                asin: '',
                developer_id: '',
                season: undefined,
                min_freight_difference: undefined,
                max_freight_difference: undefined,
                min_weight: undefined,
                max_weight: undefined,
                min_profit: undefined,
                max_profit: undefined,
                page: 1,
                limit: 10,
                total: 0,
            }
            this.getList()
        },
        //查询
        onSubmit() {
            this.query.page = 1
            this.getList()
        },
        basicData() {
            this.showBasicConfigDataModal = true
        },
        addParse() {
            this.showAddParseModal = true
        },
        // 批量删除
        batchDelete() {
            if (this.multipleSelection.length > 0) {
                this.$confirm(`确定批量删除已选择项吗?`, {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    api.variety_cost_control_analysis_delete({ids: this.multipleSelection}).then(res => {
                        if (res.code === 0) {
                            this.$message({type: 'success', message: '删除成功'})
                            this.getList()
                        } else {
                            this.$message({type: 'error', message: res.message})
                        }
                    }).catch(res => {
                        this.$message({type: 'error', message: res.message})
                    })
                }).catch(() => {
                })

            } else {
                this.$message.info('暂未选择批量处理内容')
            }
        },
        // 批量重置
        batchReset() {
            if (this.multipleSelection.length > 0) {
                this.$confirm(`确定批量重置已选择项吗?`, {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    api.variety_cost_control_analysis_batch_reset({ids: this.multipleSelection}).then(res => {
                        if (res.code === 0) {
                            this.$message({type: 'success', message: '重置成功'})
                            this.getList()
                        } else {
                            this.$message({type: 'error', message: res.message})
                        }
                    }).catch(res => {
                        this.$message({type: 'error', message: res.message})
                    })
                }).catch(() => {
                })

            } else {
                this.$message.info('暂未选择批量处理内容')
            }
        },
        change() {
            this.getList()
        },
        clearValue() {
            this.query.state = ''
        },
        //分页
        handleCurrentChange(val) {
            this.query.page = val
            this.getList()
        },
        handleSizeChange(val) {
            this.query.limit = val
            this.getList()
        },
        //上传文件
        onupload() {
            this.ctrl.uploadDialogVisible = true
        },
        //下载列表
        onDownloadList() {
            this.ctrl.DownloadListDialogVisible = true
            this.$nextTick(() => {
                this.$refs[this.activeName].getList()
            })
        },
        // bid记录列表
        openBidList(data) {
            this.currentId = data.id
            this.ctrl.bidDialogVisible = true
        },
        async startDecode(row, force = 0) {
            if (force) {
                await this.$confirm('是否重新运行解析任务', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
            }
            let list = JSON.parse(JSON.stringify(this.list))
            api.variety_cost_control_analysis_parsing_file({
                id: row.id,
                force
            }).then(() => {
                const index = list.findIndex(item => item.id === row.id)
                list[index].status = 1
                this.list = list
            })
        },
        uploadPatentFile(data){
            this.$refs.updatePatentDom.openModal(2, data)
        },
        updateVal(data) {
            this.$refs.updatePatentDom.openModal(1, data)
        },
        downFile(path) {
            if (!path) {
                return this.$message({
                    type: 'error',
                    message: '无法下载！'
                })
            }
            downloadFileUrl(path)
        },
        //添加广告优化记录
        onAddPpc(data) {
            this.record_id = data.id
            this.ctrl.addPpcDialogVisible = true
        },
        // 关闭弹窗回调
        closeCllback(isShow) {
            this.showAddRecord = false
            this.showSelfBuild = false
            this.showAddParseModal = false
            this.ctrl.childInfoVisible = false
            this.updateData = {}
            isShow == true && this.getList()
        },
        refreshList() {
            this.getList()
        },
        showDetail(data) {
            this.showSelfBuild = false
            this.getList()
            this.detailFunc(data)
        },
        update(data) {
            this.updateData = data
            this.showAddRecord = true
        }
    }
}
</script>

<style type="text/scss" lang="scss" scoped>
.redTxt {
    color: red;
    font-weight: bold;
}

.fixedHeight {
    height: 30px;
    line-height: 15px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    display: flex;
    justify-content: center;
    align-items: center;
}

.mini_div .el-button--mini {
    padding: 5px 5px !important;
}

/deep/ .el-table__expanded-cell {
    padding: 0 0 !important;
}
</style>
